<div fxLayout="column" fxLayoutAlign="start center">
  <tup-mat-content-wrapper class="main-content" position="first">
    <tup-mat-title-bar title="Welcome to the Telmar Developer Portal"></tup-mat-title-bar>
    <p></p>
    <markdown
      [src]="'assets/content/home.md'"
      (error)="onMarkdownError($event)">
    </markdown>

    <div style="padding: 16px;">
      <h2 class="mat-h2">Browse APIs:</h2>
      <mat-divider></mat-divider>
    </div>

    <app-api-list-items [showAsCards]="true"></app-api-list-items>

  </tup-mat-content-wrapper>
</div>
